exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btnmultilang[data-v-0fe152ca]{width:\"25px\";border-color:#ccc;border-radius:0;border:1px solid #ccc;background-color:#fff;background-image:none}.btnmultilang[data-v-0fe152ca]:hover{border-color:#ccc;background-color:#ccc!important}.divmultilangbtn[data-v-0fe152ca]{display:inline-block}.mutlilangactive[data-v-0fe152ca]{background-color:#ccc!important}.text[data-v-0fe152ca]{border-color:#ccc}", ""]);

// exports
